import { Button } from "@/components/ui";
import { cn } from "@/lib/utils";

export type NameState = "none" | "bad" | "info" | "warn" | "ok";

const MARK: Record<NameState, string> = {
  none: "i",
  bad: "✕",
  info: "i",
  warn: "!",
  ok: "✓",
};

const TONE: Record<NameState, string> = {
  none: "text-slate-500 dark:text-slate-400",
  bad: "text-rose-600 dark:text-rose-300",
  info: "text-indigo-600 dark:text-indigo-300",
  warn: "text-amber-700 dark:text-amber-300",
  ok: "text-emerald-700 dark:text-emerald-300",
};

type Props = {
  state: NameState;
  similar?: { label: string; onUse: () => void };
};

const message = (state: NameState, similar?: string) =>
  ({
    none: "Type a name: small letters, numbers and _.",
    bad: "Use only small letters, numbers and _. Start with a letter.",
    info: "This field already exists. Saving links to it.",
    warn: `A similar field exists: ${similar}. Same fact?`,
    ok: "This name is free.",
  })[state];

export function NameCheck({ state, similar }: Props) {
  return (
    <div
      role="status"
      className={cn("flex flex-wrap items-center gap-1.5 text-xs", TONE[state])}
    >
      <span aria-hidden className="font-bold">
        {MARK[state]}
      </span>
      <span>{message(state, similar?.label)}</span>
      {state === "warn" && similar && (
        <Button size="sm" variant="outline" onClick={similar.onUse}>
          Use {similar.label} instead
        </Button>
      )}
    </div>
  );
}
